import React from 'react';
import TabNavigation from '../../resultPage/tabNavigation';
import DataTableSection from '../../resultPage/datatable';
import { useParams } from 'react-router-dom';
import useFetch from '../../../hooks/useFetch';
import { getServicesByCategory } from '../../../services/service';
import LoadingComponent from '../../../Components/LoadingComponent/loading';
import DatalistSection from './Datalist';

const ServiceListPage = () => {
  const { query } = useParams();

  const { data: searchResults, loading, error } = useFetch(
    () => getServicesByCategory(query),
    [query] // Dependency: Fetch again when URL changes
  );

  console.log("searchResults",searchResults,error)

  // Function to capitalize the first letter of each word in the string
  const capitalizeFirstLetter = (str) => {
    return str
      .split('-') // Split the string by hyphens
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize first letter
      .join(' '); // Join the words back with a space
  };

  console.log("searchResults", searchResults);

  // Get the human-readable label for the current query
  
  const displayQuery = capitalizeFirstLetter(query);


    // Handle message based on loading, error, and response data
  let message;
  if (loading) {
    message = "Loading services...";
  } else if (error) {
    message = "Failed to load services. Please try again."; // Default error message if no specific message is returned
  } else if (searchResults?.success === false) {
    // Handle the error response from getServicesByCategory
    message = searchResults?.message || `No services found for ${displayQuery} in Jaipur`;
  } else if (searchResults?.services?.length === 0) {
    message = `No services found for ${displayQuery} in Jaipur`;
  } else {
    message = `${searchResults?.services?.length} services available for ${displayQuery} in Jaipur`;
   }

  return (
    <div className='my-[150px]'>
      <div className='w-[78%] ml-5'>
        <TabNavigation resultTab1={"Services"} totalResults={searchResults?.services?.length}/>
        <div className='py-4'>
          <p className='text-[26px] font-normal'>
          {message}
          </p>
        </div>
        {loading ? (
            <LoadingComponent />
        ) : error ? (
          <p className='text-center text-lg text-red-500'>Error fetching services. Try refreshing the page.</p>
        ) : (
          <DatalistSection servicesData={searchResults?.services} />
        )}
      </div>
      <div className='w-[5%]'></div>
      <div className='w-[25%]'></div>
    </div>
  );
};

export default ServiceListPage;
